import Vue from 'vue'
import axios from 'axios'
import { Toast, Dialog } from 'vant'

// 设置允许Vant的提示显示多个。
// Toast.allowMultiple(true)
Vue.use(Toast)
Vue.use(Dialog)

const util = {
  /**
     * 设置浏览器标题，解决了在微信里面设置标题无效的问题。
     * @param title
     */
  setTitle: function (title) {
    if (title === undefined) {
      title = 'undefined'
    }
    window.document.title = title
    var mobile = navigator.userAgent.toLowerCase()
    if (/iphone|ipad|ipod/.test(mobile)) {
      var iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      // 替换成站标favicon路径或者任意存在的较小的图片即可
      iframe.setAttribute('src', './favicon.ico')
      var iframeCallback = function () {
        setTimeout(function () {
          iframe.removeEventListener('load', iframeCallback)
          document.body.removeChild(iframe)
        }, 0)
      }
      iframe.addEventListener('load', iframeCallback)
      document.body.appendChild(iframe)
    }
  },

  /**
     * 判断是否合格的手机号码格式
     * @param num 手机号码
     * @returns {boolean} true 合格, 否则不合格
     */
  isPhoneNumber: num => {
    if (num && num.length === 11) {
      return /^[+]?(\d){1,3}[ ]?([-]?((\d)|[ ]){1,12})+$/.test(num)
    } else {
      return false
    }
  },

  /**
     * 获取url中的query
     * @param url 可以不传递
     * @returns {{}}
     */
  url2query: url => {
    url = url || window.location.href
    var urls = url.split('#')
    let query = {}
    for (var i = 0; i < urls.length; i++) {
      url = urls[i]
      let ff = url.split('?')
      // window.alert('按照？号分割=' + JSON.stringify(ff))
      // alert(JSON.stringify(ff))
      if (ff.length >= 2) {
        let msearch = ff[ff.length - 1]
        if (msearch) {
          let kvs = msearch.split('&')
          for (let index = 0; index < kvs.length; index++) {
            let kv = kvs[index].split('=')
            query[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1])// 在网页里要获取url上面的参数，获取到后必须先通过 decodeURIComponent 进行一次解码，确保拿到参数本身数据
          }
        }
      }
    }
    return query
  },

  /**
     * 网络请求工具方法。此方法中封装了请求前的加载提示和请求完毕时的提示自动隐藏。
     * @param url
     * @param data
     * @returns {{then: (function(*, *=): Promise<unknown>)}}
     */
  post: function (url, data) {
    return axios.post(url, data).then((response) => {
      if (!response) return
      if (response.data.code !== 200 && response.data.code !== 9) {
        return Promise.reject(new Error(response.data.msg)) // 这里跑出了错误。
      }
      // util.alert(response.data.msg)
      return response
    }).catch(err => {
      if (err.message) {
        sessionStorage.setItem("errorMessage", err.message);
        util.alert(err.message)
        return Promise.reject(err)
      }
    }).finally(() => {
      // loading.clear()
    })
  },
  postFile: function (url, data) {
    return axios.post(url, data, { headers: { 'Content-Type': 'multipart/form-data;boundary = ' + new Date().getTime() }
    }).then((response) => {
      if (!response) return
      if (response.data.code !== 200) {
        return Promise.reject(new Error(response.data.msg)) // 这里跑出了错误。
      }
      return response
    }).catch(err => {
      if (err.message) {
        util.alert(err.message)
        return Promise.reject(err)
      }
    }).finally(() => {
      // loading.clear()
    })
  },
  /**
     * 网络请求工具方法。此方法中封装了请求前的加载提示和请求完毕时的提示自动隐藏。
     * @param url
     * @param data
     * @returns {{then: (function(*, *=): Promise<unknown>)}}
     */
  get: function (url, data) {
    return axios.get(url, {
      params: data
    }).then((response) => {
      if (!response) return
      if (response.data.code !== 200) {
        return Promise.reject(new Error(response.data.msg)) // 这里跑出了错误。
      }
      return response
    }).catch(err => {
      if (err.message) {
        sessionStorage.setItem("errorMessage", err.message);
        util.alert(err.message)
      }

      // return Promise.reject(err)
    }).finally(() => {
      // loading.clear()
    })
  },

  // 弹出一个提示
  // toast: function (msg) {
  //   return Toast(msg)
  // },
  toast: function (msg) {
    return Toast({
      message: msg,
      duration: 2000
    })
  },

  // 显示加载框
  showLoading: function (txt) {
    return Toast.loading({
      duration: 0,
      message: txt || '加载中...',
      // forbidClick: true,//是否禁止点击
      closeOnClick: true, // 是否点击后关闭
      loadingType: 'spinner'
    })
  },

  // 隐藏所有加载框
  hideLoading: function () {
    Toast.clear(true)
  },

  // 弹出一个警告提示。
  alert: function (msg) {
    return Dialog({ message: msg })
  }
}

export default util
